import { render, staticRenderFns } from "./SideMenuExpandLink.vue?vue&type=template&id=93b74772&scoped=true"
import script from "./SideMenuExpandLink.vue?vue&type=script&lang=ts"
export * from "./SideMenuExpandLink.vue?vue&type=script&lang=ts"
import style0 from "./SideMenuExpandLink.vue?vue&type=style&index=0&id=93b74772&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b74772",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93b74772')) {
      api.createRecord('93b74772', component.options)
    } else {
      api.reload('93b74772', component.options)
    }
    module.hot.accept("./SideMenuExpandLink.vue?vue&type=template&id=93b74772&scoped=true", function () {
      api.rerender('93b74772', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/SideMenuExpandLink.vue"
export default component.exports